import { TokenService } from '../../../../../node_modules/abp-ng2-module/dist/src/auth/token.service';
import { LogService } from '../../../../../node_modules/abp-ng2-module/dist/src/log/log.service';
import { MessageService } from '../../../../../node_modules/abp-ng2-module/dist/src/message/message.service';
import { UtilsService } from '../../../../../node_modules/abp-ng2-module/dist/src/utils/utils.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConsts } from '../../../../shared/AppConsts';
import { UrlHelper } from '../../../../shared/helpers/UrlHelper';
import { AuthenticateModel, AuthenticateResultModel, TokenAuthServiceProxy } from '../../../../shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';
import { Text } from '@angular/compiler/src/i18n/i18n_ast';

import { AppComponentBase } from '../../../../shared/app-component-base';


@Injectable()
export class Login2Service  {

  static readonly twoFactorRememberClientTokenName = 'TwoFactorRememberClientToken';

  authenticateModel: AuthenticateModel;
  authenticateResult: AuthenticateResultModel;

  rememberMe: boolean;


  constructor(
    private _tokenAuthService: TokenAuthServiceProxy,
    private _router: Router,
    private _utilsService: UtilsService,
    private _messageService: MessageService,
    private _tokenService: TokenService,
    private _logService: LogService
  ) {

    this.clear();
    
  }

  authenticate( finallyCallback?: () => void): void {
    finallyCallback = finallyCallback || (() => { });
   // console.log(username);
    //console.log(password);

    //var a = username;
    //var b = password ;

    //var authModel : AuthenticateModel;
    //authModel.password = b;
    //authModel.userNameOrEmailAddress = a;
    //authModel.rememberClient = true ;

    //var str = JSON.stringify(authModel);
    //console.log(str);

    this._tokenAuthService
        .authenticate(this.authenticateModel)
        //.authenticate(authModel)
        .pipe(finalize(() => { finallyCallback(); }))
        .subscribe((result: AuthenticateResultModel) => {
            this.processAuthenticateResult(result);
        });
}

private processAuthenticateResult(authenticateResult: AuthenticateResultModel) {
  this.authenticateResult = authenticateResult;

  if (authenticateResult.accessToken) {
      // Successfully logged in
      this.login(
          authenticateResult.accessToken,
          authenticateResult.encryptedAccessToken,
          authenticateResult.expireInSeconds,
          this.rememberMe);

  } else {
      // Unexpected result!

      this._logService.warn('Unexpected authenticateResult!');
      this._router.navigate(['login/login2']);
  }
}

private login(accessToken: string, encryptedAccessToken: string, expireInSeconds: number, rememberMe?: boolean): void {

  const tokenExpireDate = rememberMe ? (new Date(new Date().getTime() + 1000 * expireInSeconds)) : undefined;

  this._tokenService.setToken(
      accessToken,
      tokenExpireDate
  );

  this._utilsService.setCookieValue(
      AppConsts.authorization.encryptedAuthTokenName,
      encryptedAccessToken,
      tokenExpireDate,
      abp.appPath
  );

  let initialUrl = UrlHelper.initialUrl;
  if (initialUrl.indexOf('/login') > 0) {
      initialUrl = AppConsts.appBaseUrl;
  }

  location.href = initialUrl;
}

  private clear(): void {
    this.authenticateModel = new AuthenticateModel();
    this.authenticateModel.rememberClient = false;
    this.authenticateResult = null;
    this.rememberMe = false;
  }
}
